module.exports = __webpack_public_path__ + "img/图片25.2b5334fe.png";